import React from "react";
import { Helmet } from "@dr.pogodin/react-helmet";

export const meta = {
  slug: "s-corp-vs-sole-prop",
  title: "S-Corp vs. Sole Proprietor: When to Make the Switch",
  description: "When an S-Corp can save self-employment tax (and when it doesn't). A practical guide for freelancers and small business owners.",
  date: "2025-01-12",
  tags: ["business structure", "S-Corp", "tax savings"]
};

export default function SCorpVsSoleProp() {
  return (
    <main className="max-w-3xl mx-auto px-6 md:px-8 py-10">
      <Helmet>
        <title>S-Corp vs. Sole Proprietor | Free1099Calc</title>
        <meta
          name="description"
          content="When an S-Corp can save self-employment tax (and when it doesn’t). A practical guide for freelancers and small business owners."
        />
      </Helmet>

      <h1 className="text-3xl font-bold mb-6">S-Corp vs. Sole Proprietor</h1>
      <p className="text-slate-700 mb-4">
        The S-Corp election can reduce self-employment tax by treating part of your profit as
        distributions rather than wages—but it also adds payroll, compliance, and bookkeeping costs.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">When it can help</h2>
      <ul className="list-disc pl-6 text-slate-700 space-y-2">
        <li>You have consistent profit above a reasonable salary for your role.</li>
        <li>You’re willing to run payroll and keep clean books.</li>
        <li>The admin cost is smaller than your expected tax savings.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3">When it may not help</h2>
      <ul className="list-disc pl-6 text-slate-700 space-y-2">
        <li>Profit is low or highly volatile.</li>
        <li>State S-Corp taxes or fees offset the savings.</li>
        <li>You prefer a simpler setup with fewer filings.</li>
      </ul>

      <p className="text-slate-700 mt-6">
        Always discuss your specific situation with a licensed CPA before electing S-Corp status.
      </p>
    </main>
  );
}
